export default __webpack_public_path__ + "static/media/elevate-swarovski-1.95be0357.png";